import { render, staticRenderFns } from "./TariffPrices.vue?vue&type=template&id=690929ec&scoped=true&"
import script from "./TariffPrices.vue?vue&type=script&lang=js&"
export * from "./TariffPrices.vue?vue&type=script&lang=js&"
import style0 from "./TariffPrices.vue?vue&type=style&index=0&id=690929ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690929ec",
  null
  
)

export default component.exports